import { Component } from '@angular/core';
import { ToasterService } from '../../core/services/visual/toaster.service';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-recover-password',
  templateUrl: './recover-password.component.html',
  styleUrls: ['./recover-password.component.css']
})
export class RecoverPasswordComponent {
  done = false;

  constructor(
    private authService: AuthService,
    private toasterService: ToasterService
  ) { }

  async onRecover(email: string) {
    try {
      await this.authService.recoverPassword(email);
      this.done = true;
    } catch (error) {
      this.toasterService.showErrorTranslating('auth.recoverPassword.error');
    }
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/auth/recover-password/recover-password.component.ts